<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col xs="12">
          <div class="card p-3 m-lg-3 mb-2">
            {{ this.$store.state.appVersion }}
            <div class="header-card">
              <p class="card-title">Quicktest's Metrics</p>
            </div>
            <div class="body-card">
              <div class="field-division">
                <span class="field-label">Today's Metrics</span>
                <mini-column
                  :chartdata="companymetrics.todaysdata"
                ></mini-column>
              </div>

              <div class="field-division">
                <span class="field-label">New Users (Last 7 days)</span>
                <mini-column :chartdata="companymetrics.newusers"></mini-column>
              </div>

              <div class="field-division">
                <span class="field-label"
                  >Monthly Users Acquisition (Last 5 Months)</span
                >
                <mini-column
                  :chartdata="companymetrics.useracquired"
                ></mini-column>
              </div>

              <div class="field-division">
                <span class="field-label">User Growth (Last 5 Months)</span>
                <mini-line :chartdata="companymetrics.usergrowth"></mini-line>
              </div>

              <div class="field-division">
                <span class="field-label">Tests Taken (Last 7 days)</span>
                <mini-column
                  :chartdata="companymetrics.newteststaken"
                ></mini-column>
              </div>

              <div class="field-division">
                <span class="field-label">New Schedules (Last 7 days)</span>
                <mini-column
                  :chartdata="companymetrics.newschedules"
                ></mini-column>
              </div>

              <div class="field-division">
                <span class="field-label">New Upgrades (Last 7 days)</span>
                <mini-column
                  :chartdata="companymetrics.newupgrades"
                ></mini-column>
              </div>

              <div class="field-division">
                <span class="field-label">Alltime Metrics</span>
                <mini-column
                  :chartdata="companymetrics.totalmetrics1"
                ></mini-column>
              </div>

              <div class="field-division">
                <span class="field-label">Alltime Metrics</span>
                <mini-column
                  :chartdata="companymetrics.totalmetrics2"
                ></mini-column>
              </div>

              <!-- <div class="field-division">
                        <span class="field-label">Test takers</span>
                        <mini-pie :chartdata="testspacestats.takerschart"></mini-pie>
                    </div>

                    <div class="field-division">
                    <span class="field-label">Test users Performance</span>
                    <mini-pie :chartdata="testspacestats.scorechart"></mini-pie>
                    </div> -->

              <!-- <div class="field-division">
                    <span class="field-label">Download results</span>
                    <div class="text-center">
                        <b-button class="mt-lg-3 action-button ml-lg-2" @click="prepareResult" variant="info"><b-icon-file-earmark-arrow-down></b-icon-file-earmark-arrow-down> Prepare fresh Result </b-button>
                        <b-button class="mt-lg-3 action-button ml-lg-2 mt-3" variant="success"><b-icon-file-earmark-arrow-down></b-icon-file-earmark-arrow-down> Download Result as CSV </b-button>
                    </div>
                    
                    </div> -->
            </div>

            <div class="footer-edit text-right mt-3">
              <!-- <b-button class="v-button p-lg-2" :to="{ name : 'edittestspaces', hash : '#users', params : { trackid : testspace.track_id} }" variant="success">Edit <b-icon-pencil-square></b-icon-pencil-square></b-button> -->
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import store from "@/store";
// import miniPie from "@/components/miniPie"
import miniColumn from "@/components/miniColumn";
import miniLine from "@/components/miniLine";
import { Capacitor } from "@capacitor/core";

export default {
  components: {
    // miniPie,
    miniColumn,
    miniLine
  },
  data() {
    return {
      // startnum: 0,
      // limitnum: this.endss,
      // intervalnum: 10,
      // endnum: 10,
      // btnrange : this.endss,
      // pages : 1
      testspace: {},
      isNativePlatform: false
    };
  },
  created() {
    setInterval(this.refetchStats, 180000);
    this.isNativePlatform = Capacitor.isNativePlatform();

    this.scheduleNotifications();

    if (!Capacitor.isNativePlatform()) {
      this.$store.state.isNativePlatform = !Capacitor.isNativePlatform();

      console.log(Capacitor.isNativePlatform());
    }
  },
  mounted() {
    this.scheduleNotifications();
  },
  beforeRouteEnter(to, from, next) {
    //   store.dispatch("admin/fetchTestspaces");
    //   store.dispatch("admin/fetchCategories");
    //   store.dispatch("admin/fetchInstitutions");

    //   let spaceid = to.params.trackid
    //   store.dispatch("admin/fetchSpacestats",{ spaceid : spaceid });
    store.dispatch("admin/fetchCompanymetrics");
    // store.dispatch("admin/fetchQuestions");

    next();
  },
  methods: {
    ...mapActions("admin", ["fetchCompanymetrics"]),

    refetchStats() {
      this.fetchCompanymetrics();
    },
    dateFormatter(rawdate) {
      let monthArray = [
        "Jan",
        "Feb",
        "Mar",
        "April",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec"
      ];
      let daysArray = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ];
      let sdate = new Date(rawdate);
      let sdatestring =
        daysArray[sdate.getUTCDay()] +
        ", " +
        monthArray[sdate.getMonth()] +
        " " +
        sdate.getDate() +
        ", " +
        sdate.getFullYear();
      // this.scheduledate = sdatestring
      // let stimestring = (sdate.getHours() < 12 ? sdate.getHours() : sdate.getHours() - 12) + ':' + (sdate.getMinutes() < 10 ? `0${sdate.getMinutes()}` : sdate.getMinutes()) + (sdate.getHours() < 12 ? 'am' : 'pm') ;
      // this.scheduletime = stimestring;

      return sdatestring;
    },
    timeformatter(rawdatetime) {
      // let monthArray = ["Jan", "Feb", "Mar", "April", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
      let sdate = new Date(rawdatetime);
      // let sdatestring =  monthArray[sdate.getMonth()] + ' ' + sdate.getDate() + ', ' + sdate.getFullYear();
      // this.scheduledate = sdatestring
      let stimestring =
        (sdate.getHours() < 12 ? sdate.getHours() : sdate.getHours() - 12) +
        ":" +
        (sdate.getMinutes() < 10
          ? `0${sdate.getMinutes()}`
          : sdate.getMinutes()) +
        (sdate.getHours() < 12 ? "am" : "pm");
      // this.scheduletime = stimestring;

      return stimestring;
    },
    makeString(rawarray) {
      let arraystring = rawarray.toString();

      return arraystring;
    },

  },

  computed: {
    ...mapState({
      testspacearray: state => state.admin.listtestspaces,
      testspacestats: state => state.admin.testspacestats,
      companymetrics: state => state.admin.companymetrics
    }),

    usetestspacearray() {
      return this.testspacearray.slice(this.startnum, this.endnum);
    },
    endss() {
      let end = this.testspacearray.length;
      return end;
    },
    ranger() {
      let ranger = Math.ceil(this.testspacearray.length / this.intervalnum);
      return ranger;
    },
    retrieving() {
      //let trid = this.$route.params.trackid;

      let curres = this.testspacearray.length;
      //this.result = curres;

      if (curres <= 0) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>
.card {
  /* min-height: 70vh; */
  background-color: rgb(242, 242, 242);
  border-radius: 20px 20px;
}
.card-title {
  font-size: 1.5rem;
  font-weight: bold;
}
.field-division {
  margin-top: 7px;
  background-color: white;
  border-radius: 10px 10px;
  padding: 10px;
}
.v-button {
  border-radius: 10px 10px;
  width: 10rem;
  /* height: 3rem; */
  background-color: #00984a;
  font-weight: bolder;
  color: white;
  position: relative;
  bottom: -80%;
  border: 0px;
  font-size: 18px;
}
.v-button:hover {
  background-color: white;
  color: #00984a;
  border: 1px solid #00984a;
}
.footer-edit {
  width: 100%;
}
.field-label {
  font-size: 1.2rem;
  font-weight: bold;
}

@media (max-width: 999px) {
  .v-button {
    width: inherit;
    /* height: 2.5rem; */
    font-size: 0.8rem;
  }
  .s-header {
    font-size: 16px;
  }
}
</style>
